import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&id=397776c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397776c0"]])

export default __exports__